import { render, staticRenderFns } from "./ElsaButtons.vue?vue&type=template&id=b94f056c&scoped=true&"
import script from "./ElsaButtons.vue?vue&type=script&lang=ts&"
export * from "./ElsaButtons.vue?vue&type=script&lang=ts&"
import style0 from "./ElsaButtons.vue?vue&type=style&index=0&id=b94f056c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94f056c",
  null
  
)

export default component.exports